import moment from 'moment'
import XLSX from 'xlsx'

let customMethods = {
    capitalize(s){
        if (typeof s !== 'string') return ''
        return s.charAt(0).toUpperCase() + s.slice(1)
    },
    // async loadAllFilters (token = null) {
    //     let filters = ['pic', 'dealer' , 'status']

    //     if(token)
    //         this.$http.defaults.headers.common['Authorization'] = "Bearer " + token;

    //     for(var i = 0 ; i < filters.length ; i++) {
    //         let curFilter = filters[i]
    //         let data = await this['get' + this.capitalize(curFilter)]();

    //         this.$store.dispatch(`set${this.capitalize(curFilter)}`, data)
    //     }
    // },
    async getPic(search = null) {
        try {
            let url = '/api/pic'
        
            if(search)
                url += '?search=' + search
            
            let response = await this.$http.get(url)

            return response.data.data
        }
        catch(err) {
            console.log(err)
        }
    },
    async getDealer() {
        try {
            let url = '/api/master/dealer'

            let response = await this.$http.get(url)

            let data = response.data.data

            for(var i = 0 ; i < data.length ; i++) {
                data[i].showName = `${data[i].loc_code} - ${data[i].name}`
            }

            return data
        }
        catch(err) {
            console.log(err)
        }
    },
    async getStatus () {
        return ['Open' , 'In Progress' , 'Done']
    }
}

export default customMethods;